import { Link } from "react-router-dom";
import { ROUTES } from "@routing/routes";
import type { FeaturedBannerProduct } from "@models/product";
import { getProductImage } from "@utils/productImage";

interface FeaturedProductBannerProps {
    product: FeaturedBannerProduct;
    categoryName: string;
}

export const FeaturedProductBanner = ({
    product,
    categoryName,
}: FeaturedProductBannerProps) => {
    const imageSrc = getProductImage(product);
    // Mockup: "{name} by {brand}". Brand is optional on Product (the
    // first-product fallback) and may be blank on the endpoint payload.
    const title = product.brand
        ? `${product.name} by ${product.brand}`
        : product.name;

    return (
        <section className="rounded-lg bg-secondary/20 mx-4 my-4 p-4 flex items-start gap-4">
            <div className="flex-1 flex flex-col gap-3">
                <p className="text-xs uppercase tracking-wide text-neutral/70">
                    Featured {categoryName}
                </p>
                <h2 className="text-lg md:text-xl font-bold text-neutral">
                    {title}
                </h2>
                <div>
                    <Link
                        to={ROUTES.PRODUCT_DETAIL(product.id)}
                        className="btn btn-sm btn-warning"
                    >
                        See Details
                    </Link>
                </div>
            </div>
            <figure className="w-28 h-28 md:w-36 md:h-36 shrink-0 overflow-hidden">
                <img
                    src={imageSrc}
                    alt={product.name}
                    className="w-full h-full object-contain"
                />
            </figure>
        </section>
    );
};
